<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('zonesCatalog.breadcrumb' | translate)]"
                      [active_item]="'zonesCatalog.detail.breadcrumb' | translate"></app-breadcrumb>
    </div>

    <div class="zone-workspace"
         [class.zone-workspace--loading]="isLoading">
      <mat-card class="zone-panel zone-panel--detail"
                [class.zone-panel--view]="isViewMode">
        <div class="zone-panel__header">
          @if (selectedZone && isViewMode) {
          <div class="zone-panel__hero-icon" aria-hidden="true">
            <mat-icon>location_on</mat-icon>
          </div>
          }
          <div class="zone-panel__heading">
            <span class="zone-panel__eyebrow">{{ 'zonesCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="zone-panel__actions">
            @if (selectedZone && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            }
          </div>
        </div>

        <div class="zone-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="zone-editor">
            <div class="zone-editor__layout">
              <div class="card zone-editor__section mb-0">
                <div class="card-body">
                  <div class="zone-section-heading">
                    <div class="zone-section-heading__title">
                      <h4>{{ 'zonesCatalog.sections.general' | translate }}</h4>
                      <span class="zone-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'zonesCatalog.sections.generalDescription' | translate }}</p>
                  </div>

                  <div class="zone-editor__form-grid">
                    @if (hasMultipleCompanies) {
                    <app-company-select class="zone-editor__field zone-editor__field--full"
                                        [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'orgUnitsCatalog.fields.company' | translate"
                                        [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event" />
                    }

                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="zone-editor__field zone-editor__field--full">
                      <mat-label>{{ 'zonesCatalog.fields.name' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'zonesCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="zone-editor__field">
                      <mat-label>{{ 'zonesCatalog.fields.icon' | translate }}</mat-label>
                        <mat-select [(ngModel)]="form.icon"
                                  [disabled]="isSaving"
                                  (ngModelChange)="onIconChange()">
                        <mat-select-trigger>
                          <div class="zone-icon-option">
                            <mat-icon>{{ selectedMaterialIcon }}</mat-icon>
                            <span>{{ selectedIconLabel }}</span>
                          </div>
                        </mat-select-trigger>
                        @for (icon of zoneIcons; track icon) {
                        <mat-option [value]="icon">
                          <div class="zone-icon-option">
                            <mat-icon>{{ getMaterialIconName(icon) }}</mat-icon>
                            <span>{{ ('zonesCatalog.icons.' + icon) | translate }}</span>
                          </div>
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="zone-editor__field">
                      <mat-label>{{ 'zonesCatalog.fields.radiusMeters' | translate }}</mat-label>
                      <input matInput
                             type="number"
                             min="10"
                             step="1"
                             [(ngModel)]="form.radiusMeters"
                             [disabled]="isSaving"
                             (ngModelChange)="onRadiusChange()">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="zone-editor__field">
                      <mat-label>{{ 'zonesCatalog.fields.lat' | translate }}</mat-label>
                      <input matInput
                             type="number"
                             step="0.000001"
                             [(ngModel)]="form.lat"
                             [disabled]="isSaving"
                             (ngModelChange)="onCoordinateInput()">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="zone-editor__field">
                      <mat-label>{{ 'zonesCatalog.fields.lng' | translate }}</mat-label>
                      <input matInput
                             type="number"
                             step="0.000001"
                             [(ngModel)]="form.lng"
                             [disabled]="isSaving"
                             (ngModelChange)="onCoordinateInput()">
                    </mat-form-field>
                  </div>

                  @if (!isCreateMode) {
                  <div class="zone-toggle-card">
                    <div>
                      <strong>{{ 'zonesCatalog.fields.isActive' | translate }}</strong>
                      <p>{{ 'zonesCatalog.fields.isActiveHint' | translate }}</p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="form.isActive"
                                      [disabled]="isSaving"></mat-slide-toggle>
                  </div>
                  }
                </div>
              </div>

              <div class="card zone-editor__section zone-editor__section--map mb-0">
                <div class="card-body">
                  <div class="zone-section-heading">
                    <div class="zone-section-heading__title">
                      <h4>{{ 'zonesCatalog.sections.map' | translate }}</h4>
                      <span class="zone-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'zonesCatalog.sections.mapDescription' | translate }}</p>
                  </div>

                  <div class="zone-map-toolbar">
                    <div class="zone-map-toolbar__summary">
                      <strong>{{ 'zonesCatalog.fields.coordinates' | translate }}</strong>
                      <span>{{ mapCoordinatesLabel }}</span>
                    </div>
                    <div class="zone-map-toolbar__summary">
                      <strong>{{ 'zonesCatalog.fields.radiusMeters' | translate }}</strong>
                      <span>{{ form.radiusMeters || 0 }} m</span>
                    </div>
                  </div>

                  <div class="zone-map-shell">
                    <div #mapContainer class="zone-map"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @else if (selectedZone; as zone) {
          <div class="zone-detail">
            <div class="zone-detail__map-card">
              <div class="zone-map-shell zone-map-shell--readonly">
                <div #mapContainer class="zone-map"></div>
                <div class="zone-map-switcher" role="group" [attr.aria-label]="'zonesCatalog.map.viewLabel' | translate">
                  <button type="button"
                          class="zone-map-switcher__button"
                          [class.zone-map-switcher__button--active]="mapStyle === 'street'"
                          (click)="setMapStyle('street')">
                    <mat-icon>map</mat-icon>
                    {{ 'zonesCatalog.map.street' | translate }}
                  </button>
                  <button type="button"
                          class="zone-map-switcher__button"
                          [class.zone-map-switcher__button--active]="mapStyle === 'satellite'"
                          (click)="setMapStyle('satellite')">
                    <mat-icon>image</mat-icon>
                    {{ 'zonesCatalog.map.satellite' | translate }}
                  </button>
                  <a class="zone-map-switcher__button zone-map-switcher__button--google"
                     [href]="googleMapsUrl"
                     target="_blank"
                     rel="noopener noreferrer">
                    <img src="assets/icon/maps.svg" alt="" aria-hidden="true">
                    {{ 'zonesCatalog.map.openGoogleMaps' | translate }}
                  </a>
                </div>
              </div>
            </div>

            <div class="zone-detail__configuration">
              <div class="zone-section-heading zone-section-heading--with-icon">
                <span class="zone-section-heading__icon" aria-hidden="true">
                  <mat-icon>settings</mat-icon>
                </span>
                <div>
                  <h4>{{ 'zonesCatalog.sections.configuration' | translate }}</h4>
                  <p>{{ 'zonesCatalog.sections.configurationDescription' | translate }}</p>
                </div>
              </div>

              <div class="zone-detail__rows">
                <div class="zone-detail__row">
                  <mat-icon>business</mat-icon>
                  <span>{{ 'zonesCatalog.fields.company' | translate }}</span>
                  <strong>{{ zone.companyName }}</strong>
                </div>
                <div class="zone-detail__row">
                  <mat-icon>adjust</mat-icon>
                  <span>{{ 'zonesCatalog.fields.type' | translate }}</span>
                  <strong>{{ zone.typeLabel }}</strong>
                </div>
                <div class="zone-detail__row">
                  <mat-icon>straighten</mat-icon>
                  <span>{{ 'zonesCatalog.fields.radiusMeters' | translate }}</span>
                  <strong>{{ zone.radiusLabel }}</strong>
                </div>
                <div class="zone-detail__row">
                  <mat-icon>{{ getMaterialIconName(zone.icon || 'place') }}</mat-icon>
                  <span>{{ 'zonesCatalog.fields.icon' | translate }}</span>
                  <strong>{{ zone.iconLabel }}</strong>
                </div>
                <div class="zone-detail__row">
                  <mat-icon class="zone-detail__status-icon"
                            [class.zone-detail__status-icon--inactive]="!zone.isActive">check_circle</mat-icon>
                  <span>{{ 'zonesCatalog.fields.status' | translate }}</span>
                  <strong>{{ zone.activeLabel }}</strong>
                </div>
                <div class="zone-detail__row zone-detail__row--coordinates">
                  <mat-icon>location_on</mat-icon>
                  <span>{{ 'zonesCatalog.fields.coordinates' | translate }}</span>
                  <strong>{{ zone.coordinatesLabel }}</strong>
                  <button mat-icon-button
                          type="button"
                          class="zone-detail__copy"
                          [attr.aria-label]="'zonesCatalog.actions.copyCoordinates' | translate"
                          [matTooltip]="'zonesCatalog.actions.copyCoordinates' | translate"
                          (click)="copyCoordinates(zone.coordinatesLabel)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="zone-empty">
            <mat-icon>place</mat-icon>
            <h4>{{ 'zonesCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'zonesCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="zone-loading"
                         [message]="'zonesCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
